import CrudCustom from '../../../libs/custom/CrudCustom';

let SilkTranskripService = new CrudCustom('/silk-transkrips');
export default SilkTranskripService;
